import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

const DisplayApologetics = () => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [topics, setTopics] = useState([]);
  const [selected, setSelected] = useState(null);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/enterprise/apologetics`)
      .then((r) => r.json())
      .then((res) => setTopics(res.data));
  }, []);

  const open = async (id) => {
    const res = await fetch(`${API_URL}/enterprise/apologetics/${id}`);
    const result = await res.json();
    setDetails(result.data);
    setSelected(id);
  };

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {topics?.map((t) => (
            <TableRow key={t.id}>
              <TableCell>{t.title}</TableCell>
              <TableCell>
                <Button onClick={() => open(t.id)}>View</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={!!details} onClose={() => setDetails(null)} fullWidth>
        <DialogTitle>{details?.title}</DialogTitle>

        <DialogContent>
          <h4>Objections</h4>
          {details?.grouped?.objection?.map((a) => (
            <p key={a.id}>{a.body}</p>
          ))}

          <h4>Responses</h4>
          {details?.grouped?.response?.map((a) => (
            <p key={a.id}>{a.body}</p>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DisplayApologetics;
